import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ApplicantPortfolioData, ObjectMemoData } from '~/types/component';
import { $device } from '.';

@Module({
  name: 'component',
  namespaced: true,
  stateFactory: true
})
export default class MyModule extends VuexModule {
  showContactModal = false;
  showLegalNotice = false;
  referer: string | undefined = undefined;
  applicantPortfolioData: ApplicantPortfolioData = undefined;
  objectMemoFavouredObjects: ObjectMemoData = undefined;
  private currentlyVisibleEstateObjectCount = 3;
  private currentlyVisibleReferenceObjectCount = 3;

  get userData(): ApplicantPortfolioData {
    return this.applicantPortfolioData;
  }

  get visibleEstateObjectCount(): number {
    return this.currentlyVisibleEstateObjectCount;
  }

  get visibleReferenceObjectCount(): number {
    return this.currentlyVisibleReferenceObjectCount;
  }

  @Mutation
  toggleShowModal(): void {
    this.showContactModal = !this.showContactModal;
  }

  @Mutation
  toggleLegalNotice(): void {
    this.showLegalNotice = !this.showLegalNotice;
  }

  @Mutation
  public setReferer(referer: string | undefined): void {
    this.referer = referer;
  }

  @Mutation
  public setApplicantPortfolioData(data: ApplicantPortfolioData): void {
    this.applicantPortfolioData = data;
  }

  @Mutation
  private setObjectMemoFavouredObjects(data: ObjectMemoData): void {
    this.objectMemoFavouredObjects = data;
  }

  @Mutation
  showMoreEstateObjects(options?: { initial?: boolean }): void {
    if (options?.initial) {
      this.currentlyVisibleEstateObjectCount = $device.isDesktop ? 6 : 3;
    } else {
      this.currentlyVisibleEstateObjectCount += $device.isDesktop ? 6 : 3;
    }
  }

  @Mutation
  showMoreReferenceObjects(options?: { initial?: boolean }): void {
    if (options?.initial) {
      this.currentlyVisibleReferenceObjectCount = $device.isDesktop ? 6 : 3;
    } else {
      this.currentlyVisibleReferenceObjectCount += $device.isDesktop ? 6 : 3;
    }
  }
}
